var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextField(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.75A.75.75 0 015.75 4h12.5a.75.75 0 01.75.75v2a.75.75 0 01-1.5 0V5.5h-4.75v13h1.5a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h1.5v-13H6.5v1.25a.75.75 0 01-1.5 0v-2z",
    fill: "#212121"
  })));
}

export default SvgTextField;